import { isNonEmptyObject } from '@sgme/fp';

export interface IError {
  errorId: string;
  parameters?: IErrorParameters;
}

export interface IErrorParameters {
  [paramKey: string]: any;
}

export class SpErrors {
  private _globalErrors: IError[] = [];
  private _fieldErrors: IDictionary<IError> = {};

  constructor(...errors: SpErrors[]) {
    if (errors) {
      errors.forEach(({ globalErrors, fieldErrors }) => {
        this._globalErrors.push(...globalErrors);
        Object.assign(this._fieldErrors, fieldErrors);
      });
    }
  }

  public addGlobalError(errorId: string, parameters?: IDictionary<any>) {
    this._globalErrors.push(parameters ? { errorId, parameters } : { errorId });
  }

  public addFieldError(field: string, errorId: string, parameters?: IDictionary<any>) {
    this._fieldErrors[field] = parameters ? { errorId, parameters } : { errorId };
  }

  public get globalErrors(): ReadonlyArray<IError> {
    return this._globalErrors;
  }

  public get fieldErrors(): Readonly<IDictionary<IError>> {
    return this._fieldErrors;
  }

  public hasError(): boolean {
    return this._globalErrors.length > 0 || isNonEmptyObject(this._fieldErrors);
  }
}
